"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getServerQueryParam = void 0;
const getServerQueryParam = ({
  url
}, queryParam) => {
  if (!url) {
    return null;
  }
  const [, paramsString] = url.split('?');
  const urlSearchParams = new URLSearchParams(paramsString);
  return urlSearchParams.get(queryParam);
};
exports.getServerQueryParam = getServerQueryParam;
